<template>
  <div class="dividing">
    <div
      class="line"
      v-if="line"
      :style="{
        borderColor
      }"
    ></div>
    <div
      class="blank"
      v-else
      :style="{
        height: blankHeight + 'px'
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    line: {
      type: Boolean,
      default: false
    },
    blankHeight: {
      type: Number,
      default: 30
    },
    borderColor: {
      type: String,
      default: "#e5e5e5"
    }
  },
  watch: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.line {
  height: 0px;
  border-width: 1px;
  border-style: solid;
  margin: 5px 0;
}
</style>
